import type { StepRulesetScope } from "./types";
import { RULESET_SCOPES } from "./types";

const STEP_RULESET_SCOPES: readonly StepRulesetScope[] = [
  RULESET_SCOPES.MESSAGE_STEP,
  RULESET_SCOPES.AUDIENCE_PATHS_STEP,
];

const STEP_RULESET_SCOPE_VALUES = new Set<string>(STEP_RULESET_SCOPES);

/**
 * Type guard: returns true when `scope` is evaluated per canvas step (a
 * `StepRulesetScope`) rather than once per Canvas.
 */
export const isStepRulesetScope = (scope: string | undefined): scope is StepRulesetScope => {
  return scope !== undefined && STEP_RULESET_SCOPE_VALUES.has(scope);
};
